import React from 'react'
import styled from 'styled-components'
import Logic, { MAX_PEOPLE } from './logic'
import axios from 'axios'

import ArrowIcon from './images/ic-arrow.svg'
import IdosoIcon from './images/idoso.component.svg'
import AdultoIcon from './images/adulto.component.svg'
import CriancaIcon from './images/crianca.component.svg'

import SIcon from './images/ic-mobilidade.component.svg'
import NIcon from './images/ic-sem-acao.component.svg'

import Form from 'containers/Form'
import Label from 'components/Label'
import Counter from 'components/Counter'
import Section from 'components/Section'
import ButtonRadio from 'components/ButtonRadio'
import RadioGroup from 'components/RadioGroup'
import UseType from 'components/UseType'
import Loading from 'components/Loading'
import Select from 'components/Select'
import FixedWrapper from 'components/FixedWrapper'
import Tip from 'components/Tip'
import { pickOrNot } from 'utils'
import { Messages } from 'validations'
import { isAdvanced, isSimple, GOOGLE_KEY } from 'config'
import uniqBy from 'lodash/uniqBy'

const GEO_LOCATION_OPTIONS = {
  maximumAge: 0,
}

/* eslint-disable camelcase */
@Logic
export default class Profile extends Form {
  nextText = `PRÓXIMO passo`

  componentDidMount() {
    const { currentLocalization } = this.props

    if (!currentLocalization) {
      navigator.geolocation.getCurrentPosition(
        this.geoSucess,
        this.geoError,
        GEO_LOCATION_OPTIONS
      )
    }
    // Scrols to top on component mount
    const element = document.getElementById('anchor')

    window.scroll({
      top: element.getBoundingClientRect().top,
    })
  }

  componentDidUpdate(oldProps) {
    if (oldProps.loading && !this.props.loading) {
      const element = document.getElementById('anchor')

      window.scroll({
        top: element.getBoundingClientRect().top,
      })
    }
    this.sendHeight()
    window.addEventListener('resize', this.sendHeight)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sendHeight)
  }

  sendHeight = () => {
    const height = document.body.scrollHeight
    window.parent.postMessage({ type: 'setHeight', height }, '*')
  }

  geoError = (error) => true

  geoSucess = (position) => {
    const { setCurrentLocation } = this.actions
    let lat
    let long

    lat = position.coords && position.coords.latitude
    long = position.coords && position.coords.longitude

    const GOOGLE_GEO_API = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&sensor=true&key=${GOOGLE_KEY}`

    try {
      const request = axios.get(GOOGLE_GEO_API)

      request.then((result) => {
        if (
          result.data.error_message ||
          result.data.status === 'OVER_QUERY_LIMIT' ||
          result.data.status === 'ZERO_RESULTS'
        ) {
          return false
        }

        let newArr = []
        result.data.results.forEach((component) => {
          newArr = [...newArr, ...component.address_components]
        })
        newArr = uniqBy(newArr, 'long_name')

        setCurrentLocation(newArr)
      })
    } catch (error) {}
  }

  /**
   * Next Button actions
   */
  next = () => {
    const { valid, invalid } = this.isFormValid()
    const { setInvalid, setFinished } = this.actions
    const { router } = this.props

    if (valid) {
      setFinished({ profileFinished: true })
      // setCurrentEquipments([]);
      router.push('/habitacao')
      window.parent.postMessage({ type: 'scrollToTop' }, '*')
    } else {
      setFinished({ profileFinished: false })
      setInvalid(invalid)

      // Move to the places
      let locationInvalid = pickOrNot(invalid, ['district', 'municipality'])
      if (locationInvalid) {
        let location = document.getElementById('location')
        if (location) {
          location.scrollIntoView({ behavior: 'smooth' })
        }

        return false
      }

      let habitantsInvalid = pickOrNot(invalid, ['adults,children,elderly'])
      if (habitantsInvalid) {
        let habitants = document.getElementById('habitants')
        if (habitants) {
          habitants.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }

  /**
   * Renders invalid messags
   */
  renderInvalidMessage = (invalid, field, name) => {
    if (invalid) {
      if (invalid[field]) {
        const Message = Messages[invalid[field]]
        if (Message) {
          return <Error>{Message(name)}</Error>
        }
      }
    }

    return null
  }

  render() {
    const {
      districts,
      cities,
      loading,
      totalPeople,
      invalid,
      translations,
      iframed,
    } = this.props

    const { setValues, fetchCities } = this.actions

    const {
      constructionYears,
      offerTypes,
      equipmentUtilizationTypes,
      equipmentUtilizationProfiles,
    } = this.props.data

    const {
      offerType,
      constructionYear,
      equipmentUtilizationType,
      equipmentUtilizationProfile,
      adults,
      electricCar,
      municipality,
      district,
      children,
      elderly,
    } = this.props.values

    const {
      SIMULATION_TARGET,
      HOUSEHOLD,
      USAGE_TYPE,
      CONSTRUCTION_YEAR,
      LOCATION,
      EQUIPMENTS_PROFILE,
    } = translations || {}

    const citiesDisabled = !district || !cities

    let locationInvalid = pickOrNot(invalid, ['district', 'municipality'])
    let habitantsInvalid = pickOrNot(invalid, ['adults,children,elderly'])

    if (loading) {
      return <Loading />
    }
    // All sections of this page
    const SimulateQuestion = (
      <Section
        title={`Simular`}
        subtitle={`O que pretende simular`}
        key={`simulate`}
        compact={iframed}>
        {SIMULATION_TARGET && <Tip data-slot='tip' text={SIMULATION_TARGET} />}
        <ButtonContainer>
          {offerTypes &&
            offerTypes.map(({ icon, text, value }, index) => (
              <ButtonRadio
                key={`ot-${index}`}
                onClick={() => {
                  if (value === 3) {
                    setValues({ electricCar: false })
                  }
                  setValues({ offerType: value })
                }}
                icon={icon}
                name={text}
                selected={offerType === value}
              />
            ))}
        </ButtonContainer>

        {offerType && offerType !== 3 && (
          <div>
            <Sep></Sep>

            <Subtitle>Tem carro eléctrico e carrega-o em casa?</Subtitle>
            <ButtonContainer>
              <ButtonRadio
                onClick={() => setValues({ electricCar: true })}
                icon={<SIcon></SIcon>}
                name={`Sim`}
                selected={electricCar === true}
              />
              <ButtonRadio
                onClick={() => setValues({ electricCar: false })}
                icon={<NIcon></NIcon>}
                name={`Não`}
                selected={electricCar === false}
              />
            </ButtonContainer>
          </div>
        )}
      </Section>
    )

    const constructionYearsQuestion = (
      <Section
        title={`Ano de construção / Reabilitação do Imóvel`}
        subtitle={`Selecione o intervalo adequado`}
        key={`construction`}
        compact={iframed}>
        {CONSTRUCTION_YEAR && <Tip data-slot='tip' text={CONSTRUCTION_YEAR} />}
        {constructionYears && (
          <RadioGroup
            items={constructionYears}
            value={constructionYear}
            onSelectionChange={({ value }) =>
              setValues({ constructionYear: value })
            }
          />
        )}
      </Section>
    )

    const localizationQuestion = (
      <Section
        title={`Localização`}
        subtitle={`Selecione o distrito e concelho`}
        className={locationInvalid && `invalid`}
        id='location'
        key={`location`}
        compact={iframed}>
        {LOCATION && <Tip data-slot='tip' text={LOCATION} />}
        {districts && (
          <WrapperLocation>
            <WrapperSelect>
              <LocationLabel fontSize='12px'>DISTRITO</LocationLabel>
              <StyledSelect
                margin
                placeholder={'Distrito'}
                items={districts}
                onChange={({ value }) => {
                  setValues({ district: value, municipality: undefined })
                  fetchCities(value)
                }}
                selected={district}
                arrowIcon={ArrowIcon}
              />
              {this.renderInvalidMessage(
                locationInvalid,
                'district',
                'Distrito'
              )}
            </WrapperSelect>
            <WrapperSelect>
              <LocationLabel fontSize='12px'>CONCELHO</LocationLabel>
              <StyledSelect
                disabled={citiesDisabled}
                placeholder={'Concelho'}
                items={cities}
                onChange={({ value }) => setValues({ municipality: value })}
                selected={municipality}
                arrowIcon={ArrowIcon}
              />
              {this.renderInvalidMessage(
                locationInvalid,
                'municipality',
                'Concelho'
              )}
            </WrapperSelect>
          </WrapperLocation>
        )}
      </Section>
    )

    const utilizationQuestion = (
      <Section
        title={`Tipo de utilização`}
        subtitle={`Selecione o tipo de utilização mais adequado`}
        key={`utilization`}
        compact={iframed}>
        {USAGE_TYPE && <Tip data-slot='tip' text={USAGE_TYPE} />}
        {equipmentUtilizationTypes && (
          <UseType
            items={equipmentUtilizationTypes}
            value={equipmentUtilizationType}
            onSelectionChange={({ value }) =>
              setValues({ equipmentUtilizationType: value })
            }
          />
        )}
      </Section>
    )

    const habitantsQuestion = (
      <Section
        title={`Agregado Familiar`}
        subtitle={`Escolha um cenário`}
        className={habitantsInvalid && `invalid`}
        id='habitants'
        key={`habitants`}
        compact={iframed}>
        {HOUSEHOLD && <Tip data-slot='tip' text={HOUSEHOLD} />}
        <WrapperHabitants>
          <Counter
            id={'adults'}
            type={'adultos'}
            value={adults}
            text={'Adultos'}
            onChange={({ value }) => setValues({ adults: value })}
            disabled={totalPeople === MAX_PEOPLE}>
            <AdultoIcon />
          </Counter>

          <Counter
            id={'children'}
            type={'criancas'}
            value={children}
            text={'Crianças'}
            onChange={({ value }) => setValues({ children: value })}
            disabled={totalPeople === MAX_PEOPLE}
            subLabel={`<18 Anos`}>
            <CriancaIcon />
          </Counter>

          <Counter
            id={'elderly'}
            type={'idosos'}
            value={elderly}
            text={'Idosos'}
            onChange={({ value }) => setValues({ elderly: value })}
            disabled={totalPeople === MAX_PEOPLE}
            subLabel={`>66 Anos`}>
            <IdosoIcon />
          </Counter>
        </WrapperHabitants>
        {this.renderInvalidMessage(
          habitantsInvalid,
          'adults,children,elderly',
          'Habitantes'
        )}
      </Section>
    )

    const equipmentProfileQuestion = (
      <Section
        title={`Perfil de utilização dos equipamentos`}
        subtitle={`Indique os seus hábitos de consumo de energia`}
        key={`equipment`}
        compact={iframed}>
        {EQUIPMENTS_PROFILE && (
          <Tip data-slot='tip' text={EQUIPMENTS_PROFILE} />
        )}
        {equipmentUtilizationProfiles && (
          <UseType
            items={equipmentUtilizationProfiles}
            value={equipmentUtilizationProfile}
            name='use_type'
            itemSize={'270px'}
            onSelectionChange={({ value }) =>
              setValues({ equipmentUtilizationProfile: value })
            }
          />
        )}
      </Section>
    )

    return (
      <Wrapper>
        {this.renderNavbar()}
        <FixedWrapper>
          {/** Renders in Simulador Avançado Order **/}
          {isAdvanced && [
            SimulateQuestion,
            constructionYearsQuestion,
            localizationQuestion,
            utilizationQuestion,
            habitantsQuestion,
            equipmentProfileQuestion,
          ]}

          {/** Renders in Simulador Simple Order **/}
          {isSimple && [
            SimulateQuestion,
            habitantsQuestion,
            utilizationQuestion,
            constructionYearsQuestion,
            localizationQuestion,
            equipmentProfileQuestion,
          ]}
        </FixedWrapper>

        {this.renderButtons()}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div``

const Sep = styled.div`
  width: 100%;
  margin: 40px 0;
  height: 1px;
  background: #dedede;
`

const Subtitle = styled.div`
  line-height: 12px;
  font-size: 12px;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  color: #010101;
  text-transform: uppercase;
  font-weight: normal;
  text-align: center;
  margin: 0;
  font-size: 100;
  position: relative;
`

const WrapperLocation = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;

    > div:first-child {
      margin-bottom: 30px;
    }
  }
`

const WrapperHabitants = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;

  > div {
    margin-left: 28px;
    margin-right: 28px;
    &:first-child {
      margin-left: 0px;
    }
    &:last-child {
      margin-right: 0px;
    }
  }

  @media screen and (max-width: 568px) {
    flex-direction: column;
    align-items: center;

    > div {
      margin: 0;
      margin-bottom: 30px;
    }
  }
`

const WrapperSelect = styled.div`
  width: 270px;
  margin: 10px;
`

const StyledSelect = styled(Select)`
  width: 100%;
  max-width: initial;

  > div {
    border: 1px solid #bababa;
    color: #3e3e3e;
  }
  ${({ margin }) => margin && `margin-right: 30px;`}
`

const LocationLabel = styled(Label)`
  text-align: left;
  padding-bottom: 5px;
`

const ButtonContainer = styled.div`
  display: flex;

  justify-content: center;
  margin-top: 32px;
`

const Error = styled.span`
  display: inline-block;
  font-size: 12px;
  color: indianred;
  margin: 10px auto;
  text-align: left;
`



// WEBPACK FOOTER //
// ./src/containers/Profile/index.js